import { forwardRef } from "react";
import { Datepicker as ReactDatepicker } from "@mobiscroll/react";
import cx from "classnames";
import PropTypes from "prop-types";

import { getCompanyDateFormat2Digit } from "@/utils/date";

import styles from "./Datepicker.module.scss";

const Datepicker = forwardRef(
  (
    {
      dateFormat: dateFormatProp,
      timeFormat,
      className,
      onChange,
      onClose,
      placeholder,
      value,
      select,
      rangeStartLabel,
      rangeEndLabel,
      disabled,
      transparent,
      maxRange,
      max,
      testId = "",
      controls,
      ...rest
    },
    ref
  ) => {
    const dateFormat = dateFormatProp ?? getCompanyDateFormat2Digit();

    return (
      <div
        className={cx(styles.wrapper, className, {
          [styles.transparent]: transparent,
          [styles.disabled]: disabled,
        })}
      >
        <ReactDatepicker
          data-testid={testId}
          ref={ref}
          dateFormat={dateFormat}
          timeFormat={timeFormat}
          themeVariant="light"
          controls={controls}
          theme="ios"
          // defaultValue={value}
          value={value}
          onChange={onChange}
          select={select}
          rangeStartLabel={rangeStartLabel}
          rangeEndLabel={rangeEndLabel}
          onClose={onClose}
          disabled={disabled}
          inputProps={{
            placeholder,
          }}
          maxRange={maxRange}
          max={max}
          {...rest}
        />
      </div>
    );
  }
);

Datepicker.displayName = "Datepicker";

Datepicker.defaultProps = {
  timeFormat: "hh:mm A",
  transparent: false,
  disabled: false,
  className: "",
  placeholder: "",
  select: "date",
  rangeStartLabel: "From",
  rangeEndLabel: "To",
  value: "",
  maxRange: undefined,
  max: null,
  controls: ["calendar"],
  onClose: () => {
    return;
  },
};

Datepicker.propTypes = {
  dateFormat: PropTypes.string,
  timeFormat: PropTypes.string,
  max: PropTypes.instanceOf(Date),
  maxRange: PropTypes.number,
  transparent: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  select: PropTypes.oneOf(["date", "range"]),
  rangeStartLabel: PropTypes.string,
  rangeEndLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  controls: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func,
};

export default Datepicker;
